import { Helmet } from "react-helmet";

const SEO = ({
  title = "GiftCard8 - Best Gift Card Trading Platform",
  description = "Trade your gift cards securely with GiftCard8. Get competitive rates and fast payments.",
  keywords = "sell gift cards, trade gift cards, best gift card rates, GC8",
  image = "https://giftcard8.com/default-image.jpg",
  url = "https://giftcard8.com/"
}) => {
  return (
    <Helmet>
      <link rel="canonical" href={url} class="dynamic-meta"></link>
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
    </Helmet>
  );
};

export default SEO;
